// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { fetchFbProfile } from '../../actions/session'
import { alert } from '../../actions/alert'
import Spinner from '../../components/Spinner'

const Container = styled.div`
  height: calc(100vh - 377px);
`

const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);
`

type Props = {
  router: Object,
  alert: Function,
  fetchFbProfile: Function
}

class FacebookCallback extends Component {
  componentDidMount() {
    const hash = window.location.hash.replace('#', '').split('&')
    if (hash.length) {
      let accessToken = ''
      for (let i = 0; i < hash.length; i++) {
        if (hash[i].match('access_token')) {
          accessToken = hash[i].split('=')[1]
        }
      }
      if (accessToken.length) {
        this.props.fetchFbProfile(accessToken)
      } else {
        this.props.router.push('/login')
        this.props.alert({ message: 'Error logging in', timeout: 4000 })
      }
    } else {
      this.props.router.push('/login')
      this.props.alert({ message: 'Error logging in', timeout: 4000 })
    }
  }

  props: Props

  render() {
    return (
      <Container>
        <Overlay>
          <Spinner />
        </Overlay>
      </Container>
    )
  }
}

export default connect(
  null,
  { fetchFbProfile, alert }
)(FacebookCallback)



// WEBPACK FOOTER //
// ./src/views/FacebookCallback/index.js